module.exports = __webpack_public_path__ + "media/images/icon-mental-8e5357ef645d5af51d79bd3505a14c36.png";